import analyticsEventValues from '@/consts/analytics/analyticsEventValues';

import StatusPageShell from '../components/StatusPageShell';
import StatusOnHoldDesktop from './StatusOnHoldDesktop';
import StatusOnHoldMobile from './StatusOnHoldMobile';

const StatusOnHold = () => (
    <StatusPageShell
        analyticsStatus={analyticsEventValues.ON_HOLD}
        Desktop={StatusOnHoldDesktop}
        Mobile={StatusOnHoldMobile}
    />
);

export default StatusOnHold;
